import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import Select from "react-select";
import {
  GetClientListNetwork,
  getMonthsYearsAction,
} from "../../redux/actions/GlobalAction";
import { getAllProviderListNetworkAction } from "../../redux/actions/TestPackageNetworkAction";
import { GetInsurerPayoutCountsNetwork, GetPendingReceivables, GetPendingReceivablesDetails, GetReceivablesDataAction } from "../../redux/actions/InsBillAction";
import { formattedDate, initPendingReceivablesState, initReceivablesState } from "./helper";
import { isLoadingAction, MandatoryStar } from "../../Utils/helper";
import { API_URL_WITHOUT_USER } from "../../Utils/API";
import { getNetworkMenuId, getToken } from "../../Utils/types";
import { placeholderSelectColor } from "../NetworkPortal/NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../common/InputOptionSelect";
import CustomPagination from "../../common/CustomPagination";
import { SearchIcon } from "../../Utils/SvgIcons";
import { TotalProveiderMonth } from "../NetworkPortal/PayOut/helper";
import {
  AdditionalApptHeader,
  payOutHeaderValue,
} from "../NetworkPortal/PayOut/AdditionalApptHeader";
import { BankDetails } from "../NetworkPortal/PayOut/BankDetails";
import { InsBankDetails } from "./InsBankDetails";
import { UpdateInvoice } from "../NetworkPortal/ProviderProfileDetails/UpdateInvoice";

export const PendingReceivables = () => {
  const [providerValues, setProviderValues] = useState(null);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [inputClient, setInputClient] = useState("");
  const [client, setClient] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initPendingReceivablesState);
  const [providerDetail, setProviderDetail] = useState([]);
  const [month, setMonth] = useState(null);
  const [header, setHeader] = useState([]);
  const [header2, setHeader2] = useState([
    { label: "Insurer Name", col: "clientName" },
    { label: "Total Pending Amount", col: "totalPending" },
    { label: "0 To 30", col: "_0To30" },
    { label: "31 To 90", col: "_31To90" },
    { label: "91 To 120", col: "_91To120" },
    { label: "Above 120", col: "above120" },
  ]);

  const [secondHeader, setSecondHeader] = useState([
    { label: "Insurer Name", col: "clientName" },
    { label: "Total Pending	Amount", col: "totalPending" },
    { label: "Total Appointments", col: "totalAppointments" },
    { label: "0 To 30", col: "_0To30" },
    { label: "31 To 90", col: "_31To90" },
    { label: "91 To 120", col: "_91To120" },
    { label: "Above 120", col: "above120" },
    { label: "Invoice Date", col: "invoiceDate" },
    { label: "Invoice Number", col: "invoiceNumber" },
    { label: "Closed Date", col: "closedDate" },
    { label: "Type", col: "type" },
  ])

  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [submitUtr, setSubmitUtr] = useState({
    isOpen: false,
    rowData: null,
  });
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const dispatch = useDispatch();

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const [screen, setScreen] = useState("first");
  const [clients, setClients] = useState([]);

  const [selectAll, setSelectAll] = useState(false);
  const [selectAllFlag, setSelectAllFlag] = useState(false);

  useEffect(() => {
    dispatch(
      GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "IBU" })
    );
    dispatch(getMonthsYearsAction());
    dispatch(getAllProviderListNetworkAction());
    dispatch(GetPendingReceivables(searchFilter));
  }, []);

  useEffect(() => {
    if (screen !== "first") {
      dispatch(GetPendingReceivablesDetails(searchFilter));
    } else {
      dispatch(GetPendingReceivables(searchFilter));
    }
  }, [screen])

  const handleSearch = () => {
    searchFilter.page=1;
    if (screen !== "first") {
      dispatch(GetPendingReceivablesDetails(searchFilter));
    } else {
      dispatch(GetPendingReceivables({
        ...searchFilter,
        // clients:providerDetail?.map((item)=>{
        //   return{
        //     clientId:item?.clientId,
        //     clientName:item?.clientName
        //   }
        // })

      }));
    }
    setProviderDetail([]);
  };

  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    if (screen !== "first") {

      dispatch(GetPendingReceivablesDetails({
        ...searchFilter,
        SortDirection:type
      }));
    } else {
      dispatch(GetPendingReceivables({
        ...searchFilter,
        SortDirection:type
      }));
    }
  };

  const downloadFile = (ele) => {
    isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    let recId = providerDetail.map((ele) => {
      return ele?.receiveId;
    });
    let clId = providerDetail.map((ele) => {
      return { clientId: ele?.clientId };
    });
    const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelPendingReceivables`;
    let data = {
      ...searchFilter,
      isExportToExcel: true,
      clients: selectAll ?  [] : clId,
      isInvoiceDetails: true,
      receiveIds: recId.length > 1 ? recId.toString() : ele?.receiveId?.toString(),
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "InsurerReceiptDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
        setProviderDetail([])

      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };

  const handleClear = () => {
    setProviderDetail([]);
    setProviderValues(null);
    setInputClient("");
    setMonth(new Date().getMonth + 1);
    if (screen !== "first") {
      searchFilter.billingType="All";
      searchFilter.basedOn="Closed Date"
      searchFilter.asOnDate=formattedDate
      searchFilter.page=1
      dispatch(GetPendingReceivablesDetails(searchFilter));
    } else {
      setSearchFilter({
        ...initPendingReceivablesState
      });
      setClients([]);
      dispatch(GetPendingReceivables(initPendingReceivablesState));
    }

    
  };

  return (
    <div className="right-section  pt-3" style={{ padding: "10px" }}>
      <div className="card staff-details-section">
        <div className="card-body">

          {screen !== "first" &&
            <div className="back-buttondiv" onClick={() => {
              setScreen("first");
              setSearchFilter({
                ...searchFilter,
                clients:[],
                page:1,
                isInvoiceDetails:false
              })
              setClients([])
            }}>
              <i className="fa-solid fa-circle-arrow-left"></i>
              <h6 style={{ cursor: "pointer" }}>Back</h6>
            </div>
          }
          <h4 className="pt-1">Pending Receivable</h4>

          <div className="mt-3 d-flex flex-wrap gap-3  ">
            <div className="payputMultiSelect">
              <Select
                placeholder="Select Client"
                getOptionLabel={(option) => option.clientName}
                getOptionValue={(option) => option.clientId}
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                onChange={(event, i, value) => {
                  console.log("event",event)
                  setClients(event);
                  changeHandler("clients", event);
                }}
                value={
                  clients
                }
                inputValue={inputClient}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") setInputClient(value);
                  if (action.action === "menu-close") {
                    setInputClient("");
                  }
                }}
                options={globalReducer?.getClientList?.map((ele) => {
                  return {
                    clientId: ele?.clientId,
                    clientName: ele?.clientName,
                    BusinessType: ele?.businessType,
                  };
                })}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
                isDisabled={screen!=="first"}
              />
            </div>

            {/* Type (All, Billed, and UnBilled) */}
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                className="white-form-select "
                style={{ height: "60px" }}
                value={searchFilter?.billingType}
                onChange={(e) => {

                  if(e.target.value==="UnBilled" || e.target.value==="All"){
                    console.log("lola",e.target.value)
                    setSearchFilter({
                      ...searchFilter,
                      billingType: e.target.value,
                      basedOn:"Closed Date"
                    });
                    
                  }else{
                    setSearchFilter({
                      ...searchFilter,
                      billingType: e.target.value,
                    });
                  }
                  
                }}
              >
                {/* <option value=""> Select Billing Type</option> */}
                {["All", "Billed", "UnBilled"]?.map((ele) => {
                  return (
                    <option value={ele}>{ele}</option>
                  );
                })}
              </select>
            </div>


            {/* Based On (Invoice Date, Closed Date) */}
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                className="white-form-select "
                style={{ height: "60px" }}
                value={searchFilter?.basedOn}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    basedOn: e.target.value,
                  });
                }}
              >
                {/* <option value=""> Select Based On</option> */}
                {["Invoice Date", "Closed Date"]?.map((ele) => {
                  return (
                    <option value={ele}>{ele}</option>
                  );
                })}
              </select>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12">
              {/* <label htmlFor="User Type" className="col-form-label">
                Invoice Date
                <MandatoryStar />
              </label> */}
              <input
                name="paymentDate"
                type="date"
                placeholder="Centre SKU Name"
                required
                style={{ height: "60px", border: "1px solid grey" }}
                className="form-control form-select-admin inputbgavanish"
                value={
                  searchFilter?.asOnDate
                    ? searchFilter?.asOnDate?.split("T")[0]
                    : null
                }
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    asOnDate: e.target.value
                  });
                }}
              />
            </div>

          </div>
          <div className="row-results ">
            <div className="me-5 d-flex gap-1">
              <select
                className="row-selectdropdown"
                value={searchFilter?.rows}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    GetPendingReceivables({
                      ...searchFilter,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                  // handleDataCount(e);
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <p className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </p>
            </div>
            <div className="d-flex gap-2">
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={handleSearch}
              >
                <a className="sidebar-links">
                  <SearchIcon />
                  <span className="sidebar-link-text">Search</span>
                </a>
              </button>
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={() => handleClear("CBU")}
              >
                <a className="sidebar-links">
                  <span className="sidebar-link-text">Clear All</span>
                </a>
              </button>
              <button
                className="btn search__btn"
                type="button"
                style={{ border: "none" }}
                disabled={providerDetail?.length < 2 && screen==="first"}
                // style={{ minWidth: "inherit" }}
                onClick={downloadFile}
              >
                <i className="fa-solid fa-arrow-down"></i> &nbsp; Export To
                Excel
              </button>

              <button
                className="dropdown-toggle appointment-dropdown "
                // style={{ width: "160px" }}
                type="button"
                id="ascDescPayableBtn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="sidebar-link-text">
                  {searchFilter?.SortDirection === "asc"
                    ? "Ascending Order"
                    : "Descending Order"}
                </span>
                <span className="sidebar-link-text">
                  <i className="fa fa-list"></i>
                </span>
              </button>
              <ul className="dropdown-menu" aria-labelledby="ascDescPayableBtn">
                <li>
                  <button
                    className="dropdown-item btn-border-bottom"
                    type="button"
                    onClick={() => handleSorting("asc")}
                  >
                    Ascending Order
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => handleSorting("desc")}
                  >
                    Descending Order
                  </button>
                </li>
              </ul>
              {/* <button
                className="search__btn ascDescBtn p-2"
                id="ascDescPayableBtn"
                onClick={() => setIsOpenSetting(true)}
                type="button"
              >
                &nbsp;
                <i class="fa-solid fa-gear" style={{ fontSize: "20px" }}></i>
              </button> */}
            </div>
          </div>
          <div className="select_all_div m-2">
          {(screen === "first" && providerDetail?.length>0) && (
                  <>
                    {!selectAll && (
                      <>
                        <p>{providerDetail?.length} Clients are selected</p>
                        {globalReducer?.getTotalCount > searchFilter.rows && (
                          <>
                            {selectAllFlag === true && (
                              <span
                                className="select_all_primary_cases"
                                onClick={() => setSelectAll(true)}
                              >
                                Select all {globalReducer?.getTotalCount}{" "}
                                Clients
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {selectAll && (
                      <p>
                        {globalReducer?.getTotalCount} Clients are selected
                      </p>
                    )}
                  </>
                )}
          </div>
         
          {screen === "first" ? (<div className="FirstScreen">
            <div className="table-responsive __custom__properties">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={
                          payoutReducer?.getPayableData?.length ===
                          providerDetail?.length
                        }
                        onClick={(e) =>
                        {
                          setSelectAllFlag(true);
                          setSelectAll(false)
                          e.target.checked
                            ? setProviderDetail(payoutReducer?.getPayableData)
                            : setProviderDetail([])
                        }
                        }
                        readOnly
                      />
                    </th>

                    {header2.map((ele) => {
                      return (
                        <th   
                          //className="addHeader"
                          style={{ textAlign: ele?.label==="Insurer Name"  ? "" : "center" }}
                        >
                          {ele?.label}
                        </th>
                      );
                    })}
                    {/* <th scope="col" style={{ textAlign: "center" }}>
                    Status
                  </th>
                  <th
                    scope="col"
                    style={{ minWidth: "100px", textAlign: "center" }}
                  >
                    Action
                  </th> */}
                  </tr>
                </thead>
                {payoutReducer?.getPayableData?.length !== 0 && (
                  <tbody>
                    {payoutReducer?.getPayableData?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              className="form-check-input"
                              style={{ textAlign: "center" }}
                              checked={providerDetail.some(
                                (item) => ele === item
                              )}
                              onClick={(e) => {
                                if (e.target.checked) {
                                  setProviderDetail([...providerDetail, ele]);
                                } else {
                                  setProviderDetail(
                                    providerDetail?.filter((item) => ele !== item)
                                  );
                                }
                              }}
                              readOnly
                            />
                          </td>
                          

                          {header2.map((item) => {
                            return (
                              <td
                                className={""}
                                style={{ textAlign: item?.label==="Insurer Name"?"" : "center" }}
                              >
                                {" "}
                                {item?.label === "Insurer Name" ?
                                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                  (<a
                                    className="text-highlighted text-decoration"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setScreen("second")
                                      setSearchFilter({
                                        ...searchFilter,
                                        clients:[{clientId:ele?.clientId,clientName:ele?.clientName}],
                                        isInvoiceDetails:true,
                                        page:1
                                      })
                                      setClients([{clientId:ele?.clientId,clientName:ele?.clientName}])
                                    }}
                                  >
                                    {ele[item?.col]}
                                  </a>) : (<p>{ele[item?.col]}</p>)}
                              </td>
                            );
                          })}

                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>
            </div>
            {payoutReducer?.getPayableData?.length === 0 && (
              <p className="noRecordFound">No Record Found</p>
            )}
            { }

            <div className="d-flex justify-content-between">
              <div className="pagination-row">
                {globalReducer?.getTotalCount !== 0 && (
                  <CustomPagination
                    totalCount={globalReducer?.getTotalCount}
                    perPageData={searchFilter?.rows}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    apiCall={GetPendingReceivables}
                    IsPayoutStatus={true}
                  />
                )}
              </div>
            </div>
            <Modal
              isOpen={submitUtr?.isOpen}
              className="modal-add-user-popup   bankDetailwidth"
              overlayClassName="overlay-history-popup network-z-index"
              ariaHideApp={false}
            >
              <InsBankDetails
                submitUtr={submitUtr}
                setSubmitUtr={setSubmitUtr}
                searchFilter={searchFilter}
              />
            </Modal>

            <Modal
              isOpen={isOpenSetting}
              // style={{maxWidth:"35%"}}
              className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
              overlayClassName="overlay-history-popup network-z-index"
              ariaHideApp={false}
            >
              <AdditionalApptHeader
                setIsOpenSetting={setIsOpenSetting}
                header={header}
                setHeader={setHeader}
                searchFilter={searchFilter}
              />
            </Modal>
          </div>)
            : (<div>


              {/* <div>
                <h4
                  className="font-bold text-highlight"
                  style={{ letterSpacing: "1px" }}
                >
                  Test Details ({""})
                </h4>
              </div> */}

              <div className="table-responsive __custom__properties">
                <table className="table" style={{ overflow: "hidden" }}>
                  <thead>
                    <tr>
                      {secondHeader?.map((ele) => {
                        return (
                          <th
                          style={{ textAlign: ele?.label==="Insurer Name" ? "" : "center" }}
                          >
                            {ele?.label}
                          </th>
                        );
                      })}
                      {/* <th scope="col" style={{ textAlign: "center" }}>
                    Status
                  </th>
                  <th
                    scope="col"
                    style={{ minWidth: "100px", textAlign: "center" }}
                  >
                    Action
                  </th> */}
                    </tr>
                  </thead>
                  {payoutReducer?.getPayableData?.length !== 0 && (
                    <tbody>
                      {payoutReducer?.getPayableData?.map((ele, index) => {
                        return (
                          <tr key={index}>
                            {secondHeader?.map((item) => {
                              return (
                                <td
                                style={{ textAlign: item?.label==="Insurer Name" ?"" : "center" }}
                                >
                                  {" "}
                                  {( item?.label==="Closed Date" || item?.label==="Invoice Date") ? ele[item?.col]?.split("T")[0] : ele[item?.col]}
                                </td>
                              );
                            })}

                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                </table>
              </div>
              {payoutReducer?.getPayableData?.length === 0 && (
                <p className="noRecordFound">No Record Found</p>
              )}
              { }

              <div className="d-flex justify-content-between">
                <div className="pagination-row">
                  {globalReducer?.getTotalCount !== 0 && (
                    <CustomPagination
                      totalCount={globalReducer?.getTotalCount}
                      perPageData={searchFilter?.rows}
                      searchFilter={searchFilter}
                      setSearchFilter={setSearchFilter}
                      apiCall={GetPendingReceivablesDetails}
                      IsPayoutStatus={true}
                    />
                  )}
                </div>
              </div>

            </div>)}



        </div>
      </div>
    </div>
  );
};

export default PendingReceivables